import { Col, Row } from "react-bootstrap";
import moment from "moment/min/moment-with-locales";

export default function ListenerHistoryRow({ item, virtualizer, virtualRow }) {
    return (
        <Row
            key={virtualRow.key}
            data-index={virtualRow?.index}
            ref={virtualizer?.measureElement}
            style={{ transform: `translateY(${virtualRow?.start ?? 0}px)` }}
            className={`py-1 border-bottom w-100 position-absolute align-items-center fs-8-xs`}>
            <Col className="text-center text-wrap-anywhere">{item.station_name}</Col>
            <Col xs={4} xl={5}>
                <Row>
                    <Col xs={12} xl={6} className="text-center text-nowrap">
                        {moment(item.start_datetime).format("L LT")}
                    </Col>
                    <Col xs={12} xl={6} className="text-center text-nowrap">
                        {moment(item.end_datetime).format("L LT")}
                    </Col>
                </Row>
            </Col>
            <Col xs={2} xl={1} className="text-center">
                {moment.utc(moment.duration(item.duration, "seconds").asMilliseconds()).format("HH:mm:ss")}
            </Col>
            <Col xs={3}>
                <Row>
                    <Col xs={12} xl={6} className="text-center text-nowrap">
                        {item.in_out}
                    </Col>
                    <Col xs={12} xl={6} className="text-center text-nowrap">
                        {item.platform}
                    </Col>
                </Row>
            </Col>
        </Row>
    );
}
